// export const apiUrl = "https://fierce-sierra-41986.herokuapp.com/";
// export const apiUrl = "https://server.cardbarter.ng/";
export const apiUrl = process.env.REACT_APP_BACKEND_URL;